import { boolean, enums, object } from "superstruct";

import { REWARDS_QR_CODE_TYPES } from "../../QRCode/types";

const RewardsStorefrontValuesPosSettingsSchema = object({
    codeType: enums([
        REWARDS_QR_CODE_TYPES.barcode_1d,
        REWARDS_QR_CODE_TYPES.barcode_2d,
    ]),
    isEnabled: boolean(),
});

export default RewardsStorefrontValuesPosSettingsSchema;
